/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoFssIcon20Solid = forwardRef('GovKoFssIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.833.833a.833.833 0 0 0-1.667 0v.959a8.251 8.251 0 0 0 0 16.416v.959a.833.833 0 1 0 1.667 0v-.959a8.251 8.251 0 0 0 0-16.416V.833ZM9.166 15.24v1.416a6.67 6.67 0 0 1 0-13.225v1.416a5.27 5.27 0 0 0 0 10.393Zm0-2.796V13.9a3.955 3.955 0 0 1 0-7.714v1.457a2.555 2.555 0 0 0 0 4.8Z" })));
});
